import React from "react";
import {
  CardBody,
} from "reactstrap";

export default function EventLink({
  eventId,
}) {
  return (
    <CardBody>
      <a href={`https://coletor.sistemasinteegra.com.br/Login?eventId=${eventId}`} target="_blank">
        Link de acesso do evento
      </a>
    </CardBody>
  )
}
